/**
 * PrimaryActionButton — shared CTA for drawer footers (Apply, Search, etc.)
 * Uses design tokens: bg-primary text-primary-foreground hover:bg-primary/90
 * In Kloutforce theme primary = pink #FF58BB, hover #FE95DB.
 * In other apps, automatically uses each app's --primary token.
 */
import * as React from 'react';
import { cn } from '../../lib/utils';

export interface PrimaryActionButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
}

export const PrimaryActionButton = React.forwardRef<HTMLButtonElement, PrimaryActionButtonProps>(
  ({ className, fullWidth = true, children, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(
        'inline-flex items-center justify-center rounded-md px-4 py-2.5 text-sm font-semibold',
        'bg-primary text-primary-foreground hover:bg-primary/90',
        'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'disabled:pointer-events-none disabled:opacity-50',
        fullWidth && 'w-full',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  ),
);

PrimaryActionButton.displayName = 'PrimaryActionButton';
